export const clearSession = () => {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("userId");
    sessionStorage.removeItem("providerId");
    sessionStorage.removeItem("companyId");
};
